import { p as proxyCustomElement, H, h, d as Host } from './p-BJEvNVLM.js';

const cosmosIconCss = ":host{color:var(--cosmos-icon-color, inherit);display:inline-block;height:var(--cosmos-icon-size, 1em);vertical-align:-0.1551724138em;width:var(--cosmos-icon-size, 1em)}svg,::slotted(svg){display:block;height:100%;width:100%}";

const CosmosIconRuler$1 = /*@__PURE__*/ proxyCustomElement(class CosmosIconRuler extends H {
    constructor() {
        super();
        this.__registerHost();
        this.__attachShadow();
    }
    getRole() {
        return this.ariaLabel ? 'img' : undefined;
    }
    getAriaHidden() {
        return this.ariaLabel ? false : 'true';
    }
    render() {
        return (h(Host, { key: '097a17c079f8ce4e2b8bd850b25bc40ecb191591', role: this.getRole(), "aria-hidden": this.getAriaHidden(), "aria-label": this.ariaLabel }, h("svg", { key: 'a0ddc3823baa6713912a1d127a87b9f2bec7b785', width: "22", height: "22", viewBox: "0 0 22 22", fill: "none", xmlns: "http://www.w3.org/2000/svg", part: "base" }, h("path", { key: 'db1de21bc53cd6e3048c9f9dac6b0e74c061d86d', "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M14.5 1.5a.5.5 0 0 1 .5.5v18a.5.5 0 0 1-.5.5h-7A.5.5 0 0 1 7 20V2a.5.5 0 0 1 .5-.5zm-6 16H11v-1H8.5v-2H11v-1H8.5v-2H11v-1H8.5v-2H11v-1H8.5v-2H11v-1H8.5V3h5v16h-5z", fill: "currentColor" }))));
    }
    static get style() { return cosmosIconCss; }
}, [1, "cosmos-icon-ruler", {
        "ariaLabel": [513, "aria-label"]
    }]);
function defineCustomElement$1() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["cosmos-icon-ruler"];
    components.forEach(tagName => { switch (tagName) {
        case "cosmos-icon-ruler":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, CosmosIconRuler$1);
            }
            break;
    } });
}

const CosmosIconRuler = CosmosIconRuler$1;
const defineCustomElement = defineCustomElement$1;

export { CosmosIconRuler, defineCustomElement };
